// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".c_row-item[data-v-dca57b24] {\n  margin-bottom: 20px;\n}\n.c_row-item .label[data-v-dca57b24] {\n  color: #999;\n}", ""]);
// Exports
module.exports = exports;
